import { LocalTime } from 'js-joda';
import { TimeValue, toLocalTime } from '@lifetools/shared-utils-time';
import { ScheduleTime } from '../../types/ScheduleTime';

// TODO: I can't find a type with `_type` in the codebase. It's possible this is a legacy type that
//       can be removed. But since I don't have time to test extensively enough, I'm leaving it in
//       here. [twl 22.Jun.23]
//
// The original comment is from 2018, so I suspect this is no longer relevant:
//
//    HACK: Until we get everything converted to the new wrapped time class, convert to a
//          `LocalTime` by unwrapping the internal value. [twl 23.Aug.18]
//
//    TODO: Remove this hack once we've standardized on a time library / wrapper. [twl 23.Aug.18]
//

const isScheduleTime = (time: ScheduleTime | TimeValue): time is ScheduleTime => (
  (time as ScheduleTime)._time !== undefined
);

export const normalizeTime = (time: ScheduleTime | TimeValue): LocalTime => (
  isScheduleTime(time) ? time._time : toLocalTime(time)!
);
